import { VehicleResponse } from "types/trip.types";
import axiosInstance from "../lib/axios";
import { BaseResponse } from "../types/responses.type";
import api from "./api";

class VehiclesService {
  static async getVehicles(): Promise<BaseResponse<VehicleResponse[]>> {
    try {
      const response = await api.get("/vehicle");
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch vehicles",
      };
    }
  }

  static async getVehicle(id: number): Promise<BaseResponse<VehicleResponse>> {
    try {
      const response = await api.get(`/vehicle/${id}`);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch vehicle",
      };
    }
  }
}

export default VehiclesService;
